import { PrepositionEnum } from '../enums/PrepositionEnum';
export const formatNameWithPreposition = ({ name }, prepositionType = PrepositionEnum.DE) => {
    return name.prepositions ? name.prepositions[prepositionType] + name.root : name.full;
};
export const formatRegionName = (place, { withPreposition }) => {
    if (withPreposition) {
        return formatNameWithPreposition(place, PrepositionEnum.A);
    }
    return place.name.full;
};
